module.exports = __webpack_public_path__ + "img/UPD.fe78ac08.png";